import { baseApi } from "configs/store-query";
import {
  TUserAuthSigninApiRequest,
  TUserAuthSigninApiResponse,
  TUserAuthSignupApiRequest,
  TUserAuthSignupApiResponse,
  TUserAuthSsoApiRequest,
  TUserAuthSsoApiResponse,
  TUserAuthVerificationSendApiRequest,
  TUserAuthVerificationSendApiResponse,
  TUserAuthVerificationVerifyApiRequest,
  TUserAuthVerificationVerifyApiResponse,
} from "apis/user/types/user-auth-api";

const BASE_PATH = "/users/auth";

export const userAuthApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    signinUserAuth: build.mutation<
      TUserAuthSigninApiResponse,
      TUserAuthSigninApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/signin`,
        method: "POST",
        ...config,
      }),
    }),
    signupUserAuth: build.mutation<
      TUserAuthSignupApiResponse,
      TUserAuthSignupApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/signup`,
        method: "POST",
        ...config,
      }),
    }),
    verifyUserAuthEmailAddressVerification: build.mutation<
      TUserAuthVerificationVerifyApiResponse,
      TUserAuthVerificationVerifyApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/email-address/verification/verify`,
        method: "POST",
        ...config,
      }),
    }),
    sendUserAuthEmailAddressVerification: build.mutation<
      TUserAuthVerificationSendApiResponse,
      TUserAuthVerificationSendApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/email-address/verification/send`,
        method: "POST",
        ...config,
      }),
    }),
    ssoUserAuth: build.mutation<TUserAuthSsoApiResponse, TUserAuthSsoApiRequest>({
      query: (config) => ({
        url: `${BASE_PATH}/sso`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
